<template>
  <div>
    <svg
      v-if="name == 'pluscircle'"
      :style="{ cursor: cursortype }"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00003 11.1114V4.88916M11.1111 8.00027H4.88892"
        :stroke="color"
        stroke-linecap="round"
      />
      <path
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
        :stroke="color"
      />
    </svg>
    <svg
      v-if="name == 'micunmute'"
      :style="{ cursor: cursortype }"
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7.4V9C14 12.0928 11.0899 14.6 7.5 14.6M7.5 14.6C3.91015 14.6 1 12.0928 1 9V7.4M7.5 14.6V17M3.78571 17H11.2143M7.5 11.4C5.96145 11.4 4.71429 10.3255 4.71429 9V3.4C4.71429 2.07452 5.96145 1 7.5 1C9.03855 1 10.2857 2.07452 10.2857 3.4V9C10.2857 10.3255 9.03855 11.4 7.5 11.4Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'micmute'"
      :style="{ cursor: cursortype }"
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7.4V9C14 12.0928 11.0899 14.6 7.5 14.6M7.5 14.6C3.91015 14.6 1 12.0928 1 9V7.4M7.5 14.6V17M3.78571 17H11.2143M7.5 11.4C5.96145 11.4 4.71429 10.3255 4.71429 9V3.4C4.71429 2.07452 5.96145 1 7.5 1C9.03855 1 10.2857 2.07452 10.2857 3.4V9C10.2857 10.3255 9.03855 11.4 7.5 11.4Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="0.633603"
        y1="14.6598"
        x2="13.6336"
        y2="0.659774"
        :stroke="color"
      />
    </svg>
    <svg
      v-if="name == 'arrowright'"
      :style="{ cursor: cursortype }"
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 5.02816C0 4.63696 0.317132 4.31982 0.708333 4.31982L12.3203 4.31982C12.7115 4.31982 13.0287 4.63696 13.0287 5.02816C13.0287 5.41936 12.7115 5.73649 12.3203 5.73649L0.708333 5.73649C0.317132 5.73649 0 5.41936 0 5.02816Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.7726 9.57655C7.49597 9.29993 7.49597 8.85144 7.7726 8.57482L11.7795 4.56788C12.0562 4.29126 12.5046 4.29126 12.7813 4.56788C13.0579 4.8445 13.0579 5.29299 12.7813 5.56961L8.77433 9.57655C8.49771 9.85317 8.04922 9.85317 7.7726 9.57655Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.80187 0.500867C8.07849 0.224246 8.52698 0.224246 8.8036 0.500867L12.8105 4.5078C13.0872 4.78443 13.0872 5.23292 12.8105 5.50954C12.5339 5.78616 12.0854 5.78616 11.8088 5.50954L7.80187 1.5026C7.52525 1.22598 7.52525 0.777489 7.80187 0.500867Z"
        :fill="color"
      />
    </svg>
    <svg
      v-if="name == 'audio'"
      :style="{ cursor: cursortype }"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5Z"
        :fill="color"
      />
      <path
        d="M23 10.125C24.5 11.6875 25 14.2917 25 16.375C25 18.4583 24.5 21.0625 23 22.625M20 13.25C20.5 13.7708 21 14.8125 21 16.375C21 17.9375 20.5 18.9792 20 19.5M7 14.8125V17.9375C7 19.0881 7.5 20.0208 9.5 20.5417C11.5 21.0625 13 25.75 16 25.75C18 25.75 18 7 16 7C13 7 11.5 11.6875 9.5 12.2083C7.5 12.7292 7 13.6619 7 14.8125Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'attach'"
      :style="{ cursor: cursortype }"
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.7917 4C26.7917 1.92894 25.1688 0.25 23.1667 0.25H3.83337C1.83135 0.25 0.208374 1.92894 0.208374 4V24C0.208374 26.0711 1.83135 27.75 3.83337 27.75H23.1667C25.1688 27.75 26.7917 26.0711 26.7917 24V4ZM24.375 4C24.375 3.30965 23.8341 2.75 23.1667 2.75H3.83337C3.16604 2.75 2.62504 3.30965 2.62504 4V24C2.62504 24.6904 3.16604 25.25 3.83337 25.25H23.1667C23.8341 25.25 24.375 24.6904 24.375 24V4Z"
        :fill="color"
      />
      <path
        d="M4.80808 20.9014L10.0226 11.0118C10.4806 10.1433 11.6862 10.1433 12.1442 11.0118L15.9729 18.2733L17.2843 15.8992C17.7482 15.0595 18.9186 15.0595 19.3824 15.8992L22.1337 20.8799C22.594 21.7131 22.0123 22.75 21.0845 22.75H5.86886C4.95166 22.75 4.36887 21.7344 4.80808 20.9014Z"
        :fill="color"
      />
      <path
        d="M20.75 9C20.75 10.3807 19.6681 11.5 18.3334 11.5C16.9986 11.5 15.9167 10.3807 15.9167 9C15.9167 7.61929 16.9986 6.5 18.3334 6.5C19.6681 6.5 20.75 7.61929 20.75 9Z"
        :fill="color"
      />
    </svg>
    <svg
      v-if="name == 'micoff'"
      :style="{ cursor: cursortype }"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" r="17.5" :fill="color" />
      <path
        d="M26 15V17.5C26 22.3325 22.1944 26.25 17.5 26.25M17.5 26.25C12.8056 26.25 9 22.3325 9 17.5V15M17.5 26.25V30M12.6429 30H22.3571M17.5 21.25C15.4881 21.25 13.8571 19.5711 13.8571 17.5V8.75C13.8571 6.67894 15.4881 5 17.5 5C19.512 5 21.1429 6.67894 21.1429 8.75V17.5C21.1429 19.5711 19.512 21.25 17.5 21.25Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line x1="4.73795" y1="25.5742" x2="30.738" y2="9.57417" stroke="white" />
    </svg>
    <svg
      v-if="name == 'micon'"
      :style="{ cursor: cursortype }"
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 18.5C36 28.165 28.165 36 18.5 36C8.83502 36 1 28.165 1 18.5C1 8.83502 8.83502 1 18.5 1C28.165 1 36 8.83502 36 18.5Z"
        :fill="color"
      />
      <path
        d="M27 16V18.5C27 23.3325 23.1944 27.25 18.5 27.25M18.5 27.25C13.8056 27.25 10 23.3325 10 18.5V16M18.5 27.25V31M13.6429 31H23.3571M36 18.5C36 28.165 28.165 36 18.5 36C8.83502 36 1 28.165 1 18.5C1 8.83502 8.83502 1 18.5 1C28.165 1 36 8.83502 36 18.5ZM18.5 22.25C16.488 22.25 14.8571 20.5711 14.8571 18.5V9.75C14.8571 7.67894 16.488 6 18.5 6C20.512 6 22.1429 7.67894 22.1429 9.75V18.5C22.1429 20.5711 20.512 22.25 18.5 22.25Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'send'"
      :style="{ cursor: cursortype }"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-311.5 -577C-311.5 -587.77 -302.77 -596.5 -292 -596.5H43C53.7696 -596.5 62.5 -587.77 62.5 -577V60C62.5 70.7696 53.7696 79.5 43 79.5H-292C-302.77 79.5 -311.5 70.7695 -311.5 60V-577Z"
        fill="none"
      />
      <path
        d="M-311.5 -577C-311.5 -587.77 -302.77 -596.5 -292 -596.5H43C53.7696 -596.5 62.5 -587.77 62.5 -577V60C62.5 70.7696 53.7696 79.5 43 79.5H-292C-302.77 79.5 -311.5 70.7695 -311.5 60V-577Z"
        stroke="white"
        stroke-opacity="0.4"
      />
      <path
        d="M-311.5 -577C-311.5 -587.77 -302.77 -596.5 -292 -596.5H43C53.7696 -596.5 62.5 -587.77 62.5 -577V60C62.5 70.7696 53.7696 79.5 43 79.5H-292C-302.77 79.5 -311.5 70.7695 -311.5 60V-577Z"
        :stroke="color"
      />
      <path
        d="M35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5Z"
        :fill="color"
      />
      <path
        d="M11.92 27.7098C12.1222 27.8009 12.3492 27.8427 12.5767 27.8304C12.8042 27.8182 13.0236 27.7525 13.2112 27.6405L29.4613 17.8905C29.6273 17.7908 29.763 17.6577 29.8567 17.5026C29.9504 17.3475 29.9994 17.175 29.9994 17C29.9994 16.8249 29.9504 16.6524 29.8567 16.4973C29.763 16.3423 29.6273 16.2092 29.4613 16.1095L13.2112 6.35946C13.0237 6.247 12.8043 6.18115 12.5766 6.16903C12.349 6.15691 12.1219 6.19899 11.9199 6.29071C11.7179 6.38243 11.5487 6.5203 11.4306 6.68938C11.3125 6.85846 11.2501 7.05232 11.25 7.24996V26.75C11.25 26.9477 11.3124 27.1417 11.4305 27.3109C11.5486 27.4801 11.7179 27.618 11.92 27.7098Z"
        fill="white"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: "IconSvg",
  props: {
    color: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    cursortype: {
      type: String,
      default: "pointer",
    },
  },
  setup() {},
};
</script>
